import { render, staticRenderFns } from "./invoiceManagement.vue?vue&type=template&id=5b54a67c&scoped=true&"
import script from "./invoiceManagement.vue?vue&type=script&lang=js&"
export * from "./invoiceManagement.vue?vue&type=script&lang=js&"
import style0 from "./invoiceManagement.vue?vue&type=style&index=0&id=5b54a67c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b54a67c",
  null
  
)

export default component.exports